import { Component, OnInit, Input } from '@angular/core';
import { PlanningEntry, Day } from '../domain/planning.model';

@Component({
  selector: 'session-short-desc',
  templateUrl: './session-short-desc.component.html'
})
export class SessionShortDescComponent implements OnInit {
  @Input() entry: PlanningEntry;

  constructor() { }

  ngOnInit(): void {
  }

  day(d: number){
    return Day[d];
  }
}
